import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * **Like Magic**
 *
 * @exports bs_425
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
     * @memberOf module:bs_425
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      let lang = document.documentElement?.lang?.slice(0, 2);

      if (thn.data.accountUserId === 1034594 && !window.location.pathname.match(/search/)) {
        lang = document.querySelector('.wpml-ls-current-language')?.textContent?.trim()?.slice(0, 2)?.toLowerCase();
      }

      // To target the messages in regards to the selected browser language in Hotel Schani Wien BE.
      const bookingEnginePages = window.location.pathname.match(/search/);
      if (thn.data.propertyId === 1027148 && bookingEnginePages) {
        lang = window.navigator.language.slice(0, 2);
      }

      if (lang && ctx.langs.test(lang)) {
        resolve(lang);
        return;
      }
      reject('no_language');
    });
  };
  /**
   * @memberOf module:bs_425
   * @see {@link generate_search_url}
   *
   * @param {object} ctx - The context object.
   */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    // https://my.schanihotels.com/search/offers?ADULTS=1&CHILDREN=&ARRIVAL=2023-10-18&DEPARTURE=2023-10-19&PROPERTY_IDS=VIESAL
    const url = new URL(ctx.baseUrl);
    const validUrl = url.pathname.match(/search/);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }
    ctx.newUrl = url.toString();
    return ctx;
  };

  /**
   * @memberOf module:bs_425
   * @see {@link onStateChange}
   *
   * @param {object} ctx - The context object.
   */
  engine.onStateChange = thn.debounce(function (ctx) {
    thn.pageCheck();
  }, 600);

  /**
     * @memberOf module:bs_425
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {
    const containerPrice = document.querySelector('#root');

    if (containerPrice) {
      let refreshPrice = thn.debounce(() => {
        const loader = thn.isVisible(document.querySelector('#lottie'));
        if (!loader) {
          ctx.widget.refresh();
        }
      }, 600, { maxWait: 1000 });

      thn.observeDom(containerPrice, refreshPrice, {
        subtree: true,
        childList: true,
        attributes: true,
        characterData: true,
      });

      thn.pageUnload(() => {
        refreshPrice.cancel();
        thn.stopObserveDom(containerPrice, refreshPrice);
        refreshPrice = null;
      });
    }
  };

  /**
    *
    * @memberOf module:bs_393
    *
    */
  const roomDetailsParseData = (numAdults, numChildren) => {
    const roomsArray = [...document.querySelectorAll('.MuiPaper-root>div.MuiGrid-root.MuiGrid-container[class*="css-1d"]')];

    if (thn.empty(roomsArray)) {
      return {};
    }

    const roomsInfo = roomsArray
      .map((room) => {
        const roomName = room.querySelector('.MuiBox-root h2')?.textContent;
        const roomType = getRoomType(roomName);
        const ratesInfo = [...room.querySelectorAll('button.MuiButtonBase-root>.MuiPaper-root')]
          ?.map((rate) => {
            const rateName = rate.querySelector('h3')?.textContent;
            const ratePrice = thn.parseNumber(rate.querySelector('h3.MuiTypography-root span.MuiBox-root')?.textContent);
            const isRefundable = rateName.includes('Flex');
            const rateData = {
              id: '',
              name: rateName,
              totalNight: ratePrice,
              breakfast: false,
              refundable: isRefundable,
            };

            return rateData;
          });

        const roomData = {
          id: '',
          name: roomName,
          adults: numAdults || 2,
          children: numChildren || 0,
          type: roomType,
          prices: ratesInfo,
        };

        return roomData;
      });

    return roomsInfo;
  };

  /**
     * @memberOf module:bs_425
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    // Dates
    const datesEl = document.querySelectorAll('.MuiButton-root .MuiGrid-root.MuiGrid-item>p.MuiTypography-root.MuiTypography-body1');
    const dateBegin = thn.parseUrlParameter('ARRIVAL')?.replace(/-/g, '/') || datesEl[0]?.textContent?.replace(/\D*(\d+)\D+(\d+)\D+(\d+)\D*/, '$3/$1/$2');
    const dateEnd = thn.parseUrlParameter('DEPARTURE')?.replace(/-/g, '/') || datesEl[1]?.textContent?.replace(/\D*(\d+)\D+(\d+)\D+(\d+)\D*/, '$3/$1/$2');
    let nights;

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
      nights = thn.daysBetween(dateBegin, dateEnd);
    }

    // Guests, Adults & Children
    const adults = thn.parseNumber(thn.parseUrlParameter('ADULTS')) || 2;
    const childrenParam = thn.parseUrlParameter('CHILDREN')?.split(',').filter(Boolean);
    const children = childrenParam?.length;
    const roomInfo = {
      adults: adults,
      children: children || 0,
      childrenAges: [],
    };

    if (children) {
      roomInfo.childrenAges = childrenParam.map((age) => (age === '0' ? 1 : thn.parseNumber(age)));
    }

    widgetData.roomsDispo = [roomInfo];

    // Prices & Currency || No Rooms
    const prices = [...document.querySelectorAll('.MuiButtonBase-root .MuiBox-root.css-0 h3 span.MuiBox-root, .MuiTypography-root.MuiTypography-h3.css-1or8kfk, .MuiButtonBase-root .MuiBox-root.css-0 > div > div > div > div > div h3')].map((price) => thn.parseNumber(price?.textContent)).filter(Boolean);
    const currency = thn.parseCurrency(document.querySelector('.MuiButtonBase-root .MuiBox-root.css-0 h3 span.MuiBox-root, .MuiTypography-root.MuiTypography-h3.css-1or8kfk, .MuiButtonBase-root .MuiBox-root.css-0 > div > div > div > div > div h3')?.textContent);
    const noAvailability = !!document.querySelector('div.MuiBox-root.css-old1by p.MuiTypography-root[class*="css-1"]') && !thn.isVisible(document.querySelector('.MuiCircularProgress-root.MuiCircularProgress-indeterminate.MuiCircularProgress-colorPrimary'));
    const loaderIsVisible = thn.isVisible(document.querySelector('.MuiCircularProgress-root'));

    if (!thn.empty(prices) && currency && nights && !loaderIsVisible) {
      widgetData.price = Math.min(...prices) / nights;
      widgetData.currency = currency;
      widgetData.roomDetails = roomDetailsParseData(widgetData.adults, widgetData.children);
      widgetData.set = true;
    } else if (noAvailability) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_425
     * @this thn.widgets.booking
     * @see {@link Booking#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingObserveDom = function bookingObserveDom(ctx) {

    const dataLayer = window.dataLayer;

    if (dataLayer) {
      // eslint-disable-next-line no-new
      new thn.DataLayerHelper(window.dataLayer, function (model, message) {
        if (message?.ecommerce && ctx.widget.setData().isSet()) {
          ctx.widget.save();
        }
      }, true);
    }
  };

  /**
     * @memberOf module:bs_425
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const dataLayer = window.dataLayer;
    const bookingId = thn.objectGet(dataLayer, 'transaction_id');

    if (!dataLayer || !bookingId) {
      widgetData.set = false;
      return widgetData;
    }

    widgetData.dateBegin = thn.objectGet(dataLayer, 'items')[0]?.arrival?.replace(/-/g, '/');
    widgetData.dateEnd = thn.objectGet(dataLayer, 'items')[0]?.departure?.replace(/-/g, '/');
    widgetData.adults = thn.objectGet(dataLayer, 'items')[0]?.adults;
    widgetData.price = thn.parseNumber(thn.objectGet(dataLayer, 'value'));
    widgetData.currency = thn.objectGet(dataLayer, 'currency');
    widgetData.bookingId = bookingId;

    return widgetData;
  };

  return engine;

}

export { factory };
